import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyCTA from "./StickyCTA";
import CookieConsent from "./CookieConsent";

export const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#020617]">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyCTA />
      <CookieConsent />
    </div>
  );
};

export default Layout;
